/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useMemo, useState } from 'react';
import './style.scss';
import PropTypes from 'prop-types';

import {
  MaterialReactTable,
  useMaterialReactTable,
  getMRT_RowSelectionHandler,
} from 'material-react-table';
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import { Box, darken, lighten, createTheme } from '@mui/material';

import ContasTable from './contasTable';
import CustosTable from './custosTable';

import MinimalTable from '../table/minimalTable';

import { ReactComponent as Close } from 'src/assets/icons/close.svg';

import { constants } from 'buffer';
import { BorderRight } from '@mui/icons-material';
import { isValid } from 'src/services/auth';

import JSONPretty from 'react-json-pretty';
var JSONPrettyMon = require('react-json-pretty/dist/monikai');

const customTheme = {
  main: 'color: #007e98; background:#f9f9f9;', // Fundo
  key: 'color: #004c5b;', // Chaves
  string: 'color: #c96800;', // Strings
  value: 'color: #b80900;', // Valores
  boolean: 'color: #99008c;', // Booleanos
  number: 'color: #4d0099;', // Números
};

export default function Rateios({ defaultValue, onClose, Title, blocked }) {
  const [newId, setNewId] = useState(0);
  const [ccnNewId, setCcNewId] = useState(0);

  const [contasData, setContasData] = useState(() => [], []);
  const [selectedConta, setSelectedConta] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [custosData, setCustosData] = useState(() => [], []);

  const [valorBase, setValorBase] = useState(defaultValue);

  const [contasSoma, setContasSoma] = useState(0);
  const [contasDiferenca, setContasDiferenca] = useState(0);

  const [ccSoma, setCcSoma] = useState(0);
  const [ccDiferenca, setCcDiferenca] = useState(0);

  const [searchModo, setSearchModo] = useState(0);
  const [showSearch, setShowSearch] = useState(false);
  const [coluna, setColuna] = useState('');

  const [check, setCheck] = useState(false);
  const [checkRow, setCheckRow] = useState(false);
  const [checkDif, setCheckDif] = useState(false);

  const [erro, setErro] = useState('teste');

  const [showFinal, setShowFinal] = useState(false);

  const [finalJson, setFinalJson] = useState({});
  useEffect(() => {
    setFinalJson({
      valorBase: valorBase,
      soma: contasSoma,
      diferenca: contasDiferenca,
      contas: contasData.map((conta) => ({
        ctaRed: Number(conta.idctared),
        ctaFin: Number(conta.idctafin),
        numPrj: Number(conta.idnumprj),
        CodFpj: Number(conta.idcodfpj),

        custos: {
          soma: contasSoma,
          diferenca: contasDiferenca,
          dados: custosData
            .flat()
            .filter((custo) => custo?.conta === conta.uid)
            .map((custo) => ({
              contaId: custo.conta,
              codccu: Number(custo.codccu),
              desccu: custo.desc,
              vlrrat: Number(custo.valor),
            })),
        },
      })),
    });

    if (contasData.length > 0) {
      setCheck(
        contasData.every((item) => {
          return (
            isValid(item.idctared) &&
            isValid(item.idctafin) &&
            isValid(item.idnumprj) &&
            isValid(item.idcodfpj)
          );
        })
      );
      setCheckDif(
        contasData.every((item) => {
          return item.dif === 0;
        })
      );
    } else {
      setCheck(false);
    }
  }, [valorBase, contasSoma, contasDiferenca, custosData, contasData]);

  const theme = createTheme({
    palette: {
      mode: 'light', // or 'dark'
      primary: {
        main: '#ff5722', // Change this to your preferred primary color
        contrastText: '#fff', // Text color on primary background
      },
    },
  });

  //light or dark green
  const baseBackgroundColor =
    theme.palette.mode === 'dark' ? 'rgba(3, 44, 43, 1)' : 'rgb(255, 255, 255)';

  const custoConfig = {
    initialState: { showGlobalFilter: true, density: 'compact' },

    layoutMode: 'grid',
    enableColumnOrdering: false,
    enableGlobalFilter: false,
    enableSorting: false,
    enablePagination: false,
    enableBottomToolbar: false,
    enableTopToolbar: false,
    enableColumnFilters: false,
    enableColumnActions: false,
    enableStickyHeader: true,
    enableRowPinning: false,
    enableRowSelection: false,
    enableSelectAll: false,
    enableBatchRowSelection: false,
    enableMultiRowSelection: false,
    rowPinningDisplayMode: 'top-and-bottom',
    enableFullScreenToggle: false,

    createDisplayMode: 'row', // ('modal', and 'custom' are also available)
    editDisplayMode: 'cell', // ('modal', 'row', 'cell', and 'custom' are also
    enableEditing: true,
    enableCellActions: true,
    positionActionsColumn: 'last',

    muiTableHeadCellProps: ({ column }) => ({
      sx: {
        marginBottom: '2rem',
        ...(column.id === 'mrt-row-select'
          ? { width: '100px', minWidth: '100px' }
          : {}),
      },
    }),
    muiTableBodyCellProps: ({ row, cell }) => ({
      onBlur: (e) => {
        if (selectedIndex === null || selectedIndex === undefined) {
          console.error('Index selecionado inválido.');
          return;
        }

        const validValue =
          e.target.value !== '' &&
          e.target.value !== '0' &&
          !isNaN(Number(e.target.value));

        setCustosData((prevData) => {
          const newData = [...prevData];

          if (newData[selectedIndex]) {
            newData[selectedIndex] = newData[selectedIndex].map(
              (item, index) =>
                index === row.index
                  ? {
                      ...item,
                      valor: Number(validValue ? e.target.value : item.valor),
                    }
                  : item
            );
          }

          return newData;
        });
        UpdateCC();
      },
      style: { cursor: 'pointer' },
      sx:
        cell.column.id === 'mrt-row-select'
          ? { width: '100px', minWidth: '100px' }
          : {},
    }),

    muiTableBodyRowProps: ({ row, staticRowIndex, table }) => ({
      onClick: (event) => {
        if (!row.getIsSelected()) {
          getMRT_RowSelectionHandler({ row, staticRowIndex, table })(event);
        }
      },
      sx: { cursor: 'pointer' },
    }),

    muiTableContainerProps: {
      sx: { height: '32vh', width: '100%' },
    },

    muiTableBodyProps: {
      sx: (theme) => ({
        '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]) > td':
          {
            backgroundColor: darken(baseBackgroundColor, 0.02),
          },
        '& tr:nth-of-type(odd):not([data-selected="true"]):not([data-pinned="true"]):hover > td':
          {
            backgroundColor: darken(baseBackgroundColor, 0.02),
          },
        '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]) > td':
          {
            backgroundColor: lighten(baseBackgroundColor, 0.02),
          },
        '& tr:nth-of-type(even):not([data-selected="true"]):not([data-pinned="true"]):hover > td':
          {
            backgroundColor: darken(baseBackgroundColor, 0.02),
          },
      }),
    },
    mrtTheme: (theme) => ({
      baseBackgroundColor: baseBackgroundColor,
      draggingBorderColor: theme.palette.secondary.main,
    }),

    localization: MRT_Localization_PT_BR,
  };

  const contaConfig = {
    initialState: { showGlobalFilter: true, density: 'compact' },

    layoutMode: 'grid',
    enableColumnOrdering: false,
    enableGlobalFilter: false,
    enableSorting: false,
    enablePagination: false,
    enableBottomToolbar: false,
    enableTopToolbar: false,
    enableColumnFilters: false,
    enableColumnActions: false,
    enableStickyHeader: true,
    enableRowPinning: false,
    enableRowSelection: true,
    enableSelectAll: false,
    enableBatchRowSelection: false,
    enableMultiRowSelection: false,
    rowPinningDisplayMode: 'top-and-bottom',
    enableFullScreenToggle: false,
    enableEditing: true,

    createDisplayMode: 'row', // ('modal', and 'custom' are also available)
    editDisplayMode: 'cell', // ('modal', 'row', 'cell', and 'custom' are also
    enableCellActions: true,
    positionActionsColumn: 'last',

    onEditingRowSave: ({ row, values, table }) => {
      setContasData((prevData) =>
        prevData.map((item, index) =>
          item.uid === row.uid
            ? {
                ...item,
                valor: Number(values.valor),
              }
            : item
        )
      );
      UpdateContas();
      selecionarConta(values.valor);
      UpdateCC();
    },

    muiTableHeadCellProps: ({ column }) => ({
      sx: {
        marginBottom: '2rem',
        ...(column.id === 'mrt-row-select'
          ? { width: '100px', minWidth: '100px' }
          : {}),
      },
    }),
    muiTableBodyCellProps: ({ cell, row }) => ({
      onBlur: (e) => {
        const value = e.target.value;

        if (isValid(value)) {
          setContasData((prevData) =>
            prevData.map((item, index) =>
              index === row.index
                ? {
                    ...item,
                    valor: Number(value),
                  }
                : item
            )
          );
          UpdateContas();
          selecionarConta(value);
          UpdateCC();
        }
      },
      style: { cursor: 'pointer' },
      sx: {
        borderRight: '1px solid #f5f5f5',
        '&:hover': {
          backgroundColor: '#f0f0f0',
          borderBottom: '1px solid lightgray',
        },
        ...(cell.column.id === 'mrt-row-select'
          ? { width: '100px', minWidth: '100px', pointerEvents: 'none' }
          : {}),
      },
      onClick: (e) => {
        if (
          cell.column.id !== 'mrt-row-select' &&
          cell.column.id !== 'valor' &&
          cell.column.id !== 'delete'
        ) {
          setColuna(cell.column.id);
          setSearchModo(0);
          setShowSearch(true);
        }
      },
    }),

    muiTableBodyRowProps: ({ row, staticRowIndex, table }) => ({
      onClick: (event) => {
        const isDeleteColumn = event.target.closest('button'); // Verifica se o clique veio de um botão

        if (isDeleteColumn) {
          setSelectedIndex(-1); // Reseta a seleção
          return; // Sai da função para evitar selecionar a linha
        }

        if (!row.getIsSelected()) {
          getMRT_RowSelectionHandler({ row, staticRowIndex, table })(event);
        }

        selecionarConta(row.original.valor);
        setSelectedIndex(row.original.uid);

        setCheckRow(
          isValid(row.original.idctared) &&
            isValid(row.original.idctafin) &&
            isValid(row.original.idnumprj) &&
            isValid(row.original.idcodfpj)
        );
      },
      sx: {
        cursor: 'pointer',
        backgroundColor:
          row.original.dif < 0 || row.original.valor > valorBase
            ? '#ed919f !important'
            : 'inherit',
      },
    }),

    muiTableContainerProps: {
      sx: { height: '32vh', width: '100%' },
    },

    localization: MRT_Localization_PT_BR,
  };

  function selecionarConta(valor) {
    setSelectedConta(valor);
  }

  function HandleContaAdd(row) {
    setContasData((prevData) => [
      ...prevData,
      {
        [coluna.toLowerCase()]: row.descta,
        id: row.codcta,
        valor: contasDiferenca,
        dif: contasDiferenca,
        uid: newId,
      },
    ]);

    setNewId((prevId) => prevId + 1);
    setShowSearch(false);
  }

  function HandleEditRow(row) {
    setContasData((prevData) =>
      prevData.map((item) => {
        if (item.uid === selectedIndex) {
          item[coluna] = `${row.codcta} - ${row.descta}`;
          item[`id${coluna}`] = row.codcta;
        }
        return item;
      })
    );

    setCheckRow(
      contasData.every((item) => {
        return (
          isValid(item.idctared) &&
          isValid(item.idctafin) &&
          isValid(item.idnumprj) &&
          isValid(item.idcodfpj)
        );
      })
    );

    setShowSearch(false);
  }

  function UpdateContas() {
    const soma = contasData.reduce(
      (acc, item) => acc + (Number(item.valor) || 0),
      0
    );

    setContasSoma(soma);

    setContasDiferenca(valorBase - soma);
  }
  useEffect(() => {
    UpdateContas();
  }, [contasData, valorBase, contasDiferenca, contasSoma]);

  function HandleCCAdd(row) {
    setCustosData((prevData) => {
      const newData = [...prevData];

      if (!newData[selectedIndex]) {
        newData[selectedIndex] = [];
      }

      newData[selectedIndex] = [
        ...newData[selectedIndex],
        {
          conta: selectedIndex,
          desc: row.descta,
          valor: ccDiferenca,
          codccu: row.codcta,
          uid: ccnNewId,
        },
      ];

      return newData;
    });

    setCcNewId((prevId) => prevId + 1);
    setShowSearch(false);
  }
  function UpdateCC() {
    let soma = 0;

    if (custosData[selectedIndex] && Array.isArray(custosData[selectedIndex])) {
      soma = custosData[selectedIndex].reduce(
        (acc, item) => acc + (Number(item.valor) || 0),
        0
      );
    }

    setCcSoma(soma);

    setCcDiferenca((Number(selectedConta) || 0) - (Number(ccSoma) || 0));
    setContasData((prevData) =>
      prevData.map((item, index) =>
        index === selectedIndex
          ? {
              ...item,
              dif: (Number(selectedConta) || 0) - (Number(ccSoma) || 0),
            }
          : item
      )
    );
  }
  useEffect(() => {
    UpdateCC();
  }, [
    custosData,
    valorBase,
    ccDiferenca,
    ccSoma,
    selectedConta,
    selectedIndex,
  ]);

  const getTitle = (coluna) => {
    switch (coluna.toLowerCase()) {
      case 'ctared':
        return 'Conta Contábil';
      case 'ctafin':
        return 'Conta Financeira';
      case 'numprj':
        return 'Projeto';
      case 'codfpj':
        return 'Fase';
      default:
        return coluna.toLowerCase();
    }
  };

  const customTheme = {
    main: 'color: #007e98; background:#f9f9f9;', // Fundo
    key: 'color: #004c5b;', // Chaves
    string: 'color: #c96800;', // Strings
    value: 'color: #b80900;', // Valores
    boolean: 'color: #99008c;', // Booleanos
    number: 'color: #4d0099;', // Números
  };

  return (
    <div className={`rateios absoluteCenter ${blocked && 'blocked'}`}>
      <div className={`debug ${showFinal && 'active'}`}>
        <JSONPretty
          id="json-pretty"
          data={JSON.stringify(finalJson)}
          theme={customTheme}
        ></JSONPretty>
      </div>

      {showSearch && (
        <div className="modal absoluteCenter consultaModal">
          <MinimalTable
            Title={getTitle(coluna)}
            porta={'GetConsRateio'}
            onClose={() => setShowSearch(false)}
            SetSearch={(row) => {
              searchModo === 0 ? HandleEditRow(row) : HandleCCAdd(row);
            }}
            aditionalParams={{ tipAca: searchModo === 0 ? 'ctafin' : 'codcc' }}
          />
        </div>
      )}

      <div className="title">
        <h2>Rateios</h2>
        <button onClick={() => onClose()}>
          <Close />
        </button>
      </div>

      <div className="rateioContent">
        <div className="header">
          <div className="infoWrapper">
            <span className="column">
              <p>Valor Base:</p>
              <p>Transação:</p>
              <p>Serviço:</p>
            </span>
            <span className="column">
              {/*<input
                type="number"
                onChange={(e) => setValorBase(e.target.value)}
                value={valorBase}
              />*/}
              R$ {Number(valorBase)?.toFixed(2)}
              <p>{'<transação>'}</p>
              <p>{'<serviço>'}</p>
            </span>
            <span className="column">
              <p>Origem:</p>
            </span>
            <span className="column">
              <p>{Title}</p>
            </span>
          </div>
          Contas
          <button
            className={`rowAdd ${blocked && 'hide'}`}
            onClick={
              () => {
                HandleContaAdd({});
              } /*HandleContaAdd()*/
            }
            disabled={
              !(
                (contasDiferenca > 0 && checkDif && check) ||
                (contasData.length < 1 && contasDiferenca > 0)
              )
            }
          >
            <span>Adicionar</span>
            {!(
              (contasDiferenca > 0 && checkDif && check) ||
              (contasData.length < 1 && contasDiferenca > 0)
            ) && (
              <div className="erroRat">
                <span>
                  {contasDiferenca <= 0
                    ? 'Não há valor disponível'
                    : !check
                      ? 'Linha inválida'
                      : !checkDif
                        ? 'Valor não rateado'
                        : ''}
                </span>
              </div>
            )}
          </button>
        </div>
        <Box
          sx={{
            height: 'auto',
            width: '100%',
            position: 'relative',
            border: '1px solid lightgray',
          }}
        >
          <ContasTable
            config={contaConfig}
            data={contasData}
            setSearch={() => setShowSearch(true)}
            setColuna={(col) => setColuna(col)}
            handleDelete={(row) => {
              setContasData((prev) =>
                prev.filter((item) => item.uid !== row.original.uid)
              );
            }}
          />
        </Box>
        <div className="infoWrapper">
          <span className="column">
            <p>Soma:</p>
          </span>
          <span className="column">
            <p>{contasSoma}</p>
          </span>
          <span className={`column ${contasDiferenca < 0 && 'difErro'}`}>
            <p>Diferença:</p>
          </span>
          <span className={`column ${contasDiferenca < 0 && 'difErro'}`}>
            <p>{contasDiferenca}</p>
          </span>
        </div>
        <div className="header">
          Centro de Custo {selectedIndex}
          <button
            className={`rowAdd ${blocked && 'hide'}`}
            onClick={() => {
              setSearchModo(1);
              setShowSearch(true);
            }} /*HandleContaAdd()*/
            disabled={!checkRow || !(ccDiferenca > 0)}
          >
            <span>Adicionar</span>
            {(!checkRow || !(ccDiferenca > 0)) && (
              <div className="erroRat">
                <span>
                  {selectedIndex === -1
                    ? 'Nenhuma linha selecionada'
                    : !checkRow
                      ? 'Linha inválida'
                      : ccDiferenca <= 0
                        ? 'Não há valor disponível'
                        : ''}
                </span>
              </div>
            )}
          </button>
        </div>
        <Box
          sx={{
            height: 'auto',
            width: '100%',
            position: 'relative',
            border: '1px solid lightgray',
          }}
        >
          <CustosTable
            config={custoConfig}
            data={custosData[selectedIndex] || []}
            handleDelete={(row) => {
              setCustosData((prev) =>
                prev.map((group) =>
                  Array.isArray(group)
                    ? group.filter((item) => item.uid !== row.original.uid)
                    : group
                )
              );
            }}
          />
        </Box>
        <div className="infoWrapper">
          <span className="column">
            <p>Soma:</p>
            {/*<p>SELECIONADO</p>*/}
          </span>
          <span className="column">
            <p>{ccSoma}</p>
            {/*<p>
              {selectedIndex} | {selectedConta}
            </p>*/}
          </span>
          <span className={`column ${ccDiferenca < 0 && 'difErro'}`}>
            <p>Diferença:</p>
          </span>
          <span className={`column ${ccDiferenca < 0 && 'difErro'}`}>
            <p>{ccDiferenca}</p>
          </span>

          <div className="rateioSalvar">
            <button
              className="mainButton turquoise"
              onClick={() => setShowFinal(true)}
              //disabled={!check || !checkDif}
            >
              Mostrar
            </button>
            <button
              className="mainButton red"
              onClick={() => setShowFinal(false)}
              //disabled={!check || !checkDif}
            >
              Esconder
            </button>
            <span>
              {contasData.length < 1
                ? 'Não há conteúdo'
                : !check
                  ? 'Existem linhas inválidas'
                  : !checkDif
                    ? 'Existem valores não rateados'
                    : ''}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

Rateios.propTypes = {
  onClose: PropTypes.func.isRequired,
  defaultValue: PropTypes.string,
  Title: PropTypes.string,
};
